import { PLACEHOLDER_CASAVO } from '@proprioo/hokkaido';

import { ListingPictureProps } from '../interfaces';

export const generatePlaceholderPicture = (): ListingPictureProps => ({
  attachment: PLACEHOLDER_CASAVO,
  dir: '',
  id: 'placeholder',
  name: '',
  position: 0
});
